import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { IotDataLogList } from './iot-data-log/iot-data-log-list/iot-data-log-list';
import { ManagIotList } from './manage-iot/manag-iot-list/manag-iot-list';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-iot',
  imports: [IotDataLogList, ManagIotList],
  templateUrl: './iot.html',
  styleUrl: './iot.scss'
})
export class Iot implements OnInit {
  @ViewChild('manageIot') manageIotList!: ManagIotList;

  activeTab = 0;

  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const tab = params.get('tab');
      if (tab !== null) this.activeTab = +tab;
    });
  }

  switchTab(tab: number) {
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }

  openAddIot() {
    this.manageIotList?.openAddIotDialog();
  }
}
